export class Estatutos {

    static estatutosLista: Estatutos[] = [
        { tipo: 'docLink', descricao: 'Estatuto', caminho: 'https://www.centrus.org.br/wp-content/uploads/2020/08/11-estatuto_20_03_2015.pdf' },
        { tipo: 'docLink', descricao: '14/03/2014 a 18/03/2015', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/10-estatuto_14_03_2014.pdf' },
        { tipo: 'docLink', descricao: '18/09/2012 a 13/03/2014', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/09-estatuto_18_09_2012.pdf' },
        { tipo: 'docLink', descricao: '26/10/2009 a 17/09/2012', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/08-estatuto_26_10_2009.pdf' },
        { tipo: 'docLink', descricao: '16/04/2007 a 25/10/2009', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/07-estatuto_16_04_2007.pdf' },
        { tipo: 'docLink', descricao: '24/02/2003 a 15/04/2007', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/06-estatuto_24_02_2003.pdf' },
        { tipo: 'docLink', descricao: '03/06/2002 a 23/02/2003', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/05-estatuto_03_06_2002.pdf' },
        { tipo: 'docLink', descricao: '20/12/2000 a 02/06/2002', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/04-estatuto_20_12_2000.pdf' },
        { tipo: 'docLink', descricao: '04/06/1990 a 19/12/2000', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/03-estatuto_04_06_1990.pdf' },
        { tipo: 'docLink', descricao: '11/05/1988 a 03/06/1990', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/02-estatuto_11_05_1988.pdf' },
        { tipo: 'docLink', descricao: '02/04/1980 a 10/05/1988', caminho: 'https://sef.centrus.org.br/cent/images/docs/pdf/01-estatuto_02_04_1980.pdf' }

    ];

    constructor(
        public tipo: string,
        public descricao: string,
        public caminho: string
    ) {

    }




}




// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/util/dados-documentos-institucional/lista-documentos/estatutos.ts